export type UserData = {
    id: string;
    name: string;
    email: string;
    avatar?: string;
    phone?: string | null;
    profile_id?: string | null;
};

export type DeleteAccountPayload = {
    reason?: string | null;
    password: string;
    teams?: string[];
};
